import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemThamQuyen extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }

  }
  componentDidMount() {

  }
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ten}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.moTa}</li>
          </ul>
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('THAMQUYENGIAIQUYET_SUA') ?
                <Link className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)} >Chỉnh sửa</Link>
              : null
            }
            {
              CheckPermission('THAMQUYENGIAIQUYET_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.thamQuyenGiaiQuyetId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemThamQuyen.jsx